module.exports = __webpack_public_path__ + "img/element-auth_form.07f7f84.svg";